import { createContext } from 'react';

import { TTitleContext } from '@models/Title';

const TitleContext = createContext<TTitleContext>({} as TTitleContext);

export default TitleContext;
